import AppRoutes from '@/routes/AppRoutes';
import ComponentNavigation from '@/navigation/ComponentNavigation'
import { useSsoLogin } from '@gyandiksha/shared-ui/hooks';

const App = () => {
  const isERPUserLoginReady = useSsoLogin();

  if (!isERPUserLoginReady) {
    return null;
  }

  return (
    <div>
      <AppRoutes componentRoutes={ComponentNavigation} />
    </div>
  )
}

export default App
